import React from 'react';
import { StepLabelSC, StepCount, StepHeading } from './StepLabel.style';
import { useTranslation } from 'react-i18next';

export const StepLabel = ({ id, stepCount, children }) => {
  const { t } = useTranslation();
  return (
    <StepLabelSC id={id}>
      <StepCount>{t(stepCount)}</StepCount>
      <StepHeading>{children}</StepHeading>
    </StepLabelSC>
  );
};
